import { Reveal } from "@/components/Reveal";

export default function PageHeader({ overline, title, subtitle }) {
  return (
    <section className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-36 lg:pt-44 pb-10">
      <Reveal>
        <span className="overline text-royal inline-flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald" />{overline}
        </span>
      </Reveal>
      <Reveal delay={0.1}>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-foreground leading-[1.02] max-w-4xl">{title}</h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base lg:text-lg text-muted-foreground leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
    </section>
  );
}
